export const getBaseUrl = () => {
  const { host, protocol } = window.location

  return `${protocol}//${host}`
}
